import Vue from 'vue'
import App from './App.vue'
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Global } from '@/global/index';
import router from './router';

window.$global = new Global()
Vue.use(ElementUI)

Vue.mixin({
  data () {
    return {
      global: window.$global
    }
  }
})

let vueItem = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

console.log(vueItem)
